export const NOTIFICATIONS_DESCRIPTION = {
    message: {
        icon: require('./../../../assets/ic-message.svg')
    },
    guestbook: {
        icon: require('./../../../assets/ic-message.svg')
    },
    gift: {
        icon: require('./../../../assets/ic-gift-blue.svg')
    },
    follower: {
        icon: require('./../../../assets/ic-followers.svg')
    },
    newContribution: {
        icon: require('./../../../assets/ic-new-contribution.svg')
    },
    premiumEnds: {
        icon: require('./../../../assets/ic-exclamation.svg')
    },
    premiumEnded: {
        icon: require('./../../../assets/ic-exclamation.svg')
    },
    premium: {
        icon: require('./../../../assets/ic-gift-blue.svg')
    },
    mapUser: {
        icon: require('./../../../assets/ic-map-marker-blue.svg'),
        text: 'New user near you',
        variant: 'No user'
    },
    followee_ephemeral: {
        icon: require('./../../../assets/ic-new-contribution.svg'),
        text: 'New temporary photo',
        variant: 'No user'
    },
    ephemeral: {
        icon: require('./../../../assets/ic-new-contribution.svg'),
        text: 'New temporary photo',
        variant: 'No user'
    },
    ephemeral_comment: {
        icon: require('./../../../assets/ic-new-contribution.svg'),
        text: 'New ephemeral comment',
        variant: 'No user'
    },
    contribution_comment: {
        icon: require('./../../../assets/ic-message.svg'),
        text: 'New contribution comment',
        variant: 'No user'
    }
}
